const productData = [
  {
    id: 1,
    name: "Strong Volt Vpn",
    image: "https://i.ibb.co/67rCfs8p/favicon.png",
    productType: "openBackHeadphones",
    description: ["OVPN", "UDP", "V2RAY", "SSH", "SLOWDNS"],
    rating: 5,
    timeLeft: 27,
    appLink: "https://gitlab.com/mtkdev1/dextereskalarte/-/raw/main/strongvoltvpn.apk"
 // },
 // {
 //  id: 2,
  //  name: "Strong Volt Xray",
   // image: "https://i.ibb.co/67rCfs8p/favicon.png",
  //  productType: "openBackHeadphones",
  //  description: ["XRAY"],
  //  rating: 5,
 //   timeLeft: 24,
 //   appLink: "https://gitlab.com/mtkdev1/dextereskalarte/-/raw/main/strongvoltxray-release.apk"
  }
];

export default productData;
